export function FAQ() {
  const items = [
    {
      q: 'Do I need to connect Stripe?',
      a: 'No. You get valuation + signals with CSV or sample data. Read‑only Stripe unlocks deeper analysis and better warm paths.'
    },
    {
      q: 'Are investor intros guaranteed?',
      a: 'No. Intros are gated behind readiness and evidence to avoid spam loops. Laurel sells clarity, not promises.'
    },
    {
      q: 'Where is my data stored?',
      a: 'Canada‑first by default. Read‑only tokens, scoped permissions, and instant revocation.'
    },
  ]

  return (
    <section id="faq" className="mx-auto max-w-5xl px-4 md:px-6 py-10">
      <h3 className="text-2xl font-semibold">FAQ</h3>
      <div className="mt-6 grid md:grid-cols-3 gap-4">
        {items.map((it) => (
          <div key={it.q} className="card rounded-2xl p-5">
            <div className="font-medium">{it.q}</div>
            <div className="text-sm text-[#b8c4ef] mt-2">{it.a}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
